// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1Sa17","filesListContainer":"PosDisputesFiles_filesListContainer__1lCkf","filesButton":"PosDisputesFiles_filesButton__SGdVC"};